import { LoadTeamMember } from '@/components/hoc/LoadTeamMember';
import { RequireFixedAsset } from '@/components/hoc/RequireFixedAsset';
import { RequireInvoiceTask } from '@/components/hoc/RequireInvoiceTask';
import { RequirePaymentTask } from '@/components/hoc/RequirePaymentTask';
import { RequirePurchaseOrder } from '@/components/hoc/RequirePurchaseOrder';
import { RequirePurchaseOrderContractTask } from '@/components/hoc/RequirePurchaseOrderContractTask';
import { RequireQuotationTask } from '@/components/hoc/RequireQuotationTask';
import { RequireSalesOrder } from '@/components/hoc/RequireSalesOrder';
import { RequireSalesOrderContractTask } from '@/components/hoc/RequireSalesOrderContractTask';
import { RequireSignIn } from '@/components/hoc/RequireSignIn';
import { RequireTeam } from '@/components/hoc/RequireTeam';
import { RequireWorkspaceMember } from '@/components/hoc/RequireWorkspaceMember';
import { MyProfile } from '@/features/my_profile';
import { EditPassword } from '@/features/my_profile/edit_password';
import { PasswordReset } from '@/features/password_reset';
import { PasswordResetCode } from '@/features/password_reset/code';
import { PasswordResetNew } from '@/features/password_reset/new';
import { SignIn } from '@/features/sign_in';
import { SignUp } from '@/features/sign_up';
import { SignUpVerifyCode } from '@/features/sign_up/verify_code';
import { ApprovalTasks } from '@/features/w/[identifier]/approval';
import { ApprovalPurchaseOrderContractTask } from '@/features/w/[identifier]/approval/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]';
import { ApprovalPurchaseOrderContractTaskEdit } from '@/features/w/[identifier]/approval/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/edit';
import { ApprovalPurchaseOrderContractTaskFiles } from '@/features/w/[identifier]/approval/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/purchase_order_contract_task_files';
import { ApprovalQuotationTask } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]';
import { ApprovalQuotationTaskEdit } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/edit';
import { ApprovalQuotationTaskFiles } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/quotation_task_files';
import { ApprovalSalesOrderContractTask } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]';
import { ApprovalSalesOrderContractTaskEdit } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/edit';
import { ApprovalSalesOrderContractTaskFiles } from '@/features/w/[identifier]/approval/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/sales_order_contract_task_files';
import { BackofficeInvoiceTasks } from '@/features/w/[identifier]/backoffice/invoice_tasks';
import { BackofficePaymentTasks } from '@/features/w/[identifier]/backoffice/payment_tasks';
import { BackofficePurchaseOrderContractTasks } from '@/features/w/[identifier]/backoffice/purchase_order_contract_tasks';
import { BackofficeQuotationTasks } from '@/features/w/[identifier]/backoffice/quotation_tasks';
import { BackofficeSalesOrderContractTasks } from '@/features/w/[identifier]/backoffice/sales_order_contract_tasks';
import { BackofficePaymentTask } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]';
import { BackofficePaymentTaskEdit } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/edit';
import { BackofficePaymentTaskExpenseAccountItems } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_expense_account_items';
import { BackofficePaymentTaskFiles } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_files';
import { BackofficePaymentTaskFixedAssets } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_fixed_assets';
import { BackofficePaymentTaskOrderAllocatedExpenses } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_order_allocated_expenses';
import { BackofficePurchaseOrderContractTask } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]';
import { BackofficePurchaseOrderContractTaskEdit } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/edit';
import { BackofficePurchaseOrderContractTaskFiles } from '@/features/w/[identifier]/backoffice/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/purchase_order_contract_task_files';
import { BackofficeInvoiceTask } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]';
import { BackofficeInvoiceTaskEdit } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]/edit';
import { BackofficeInvoiceTaskFiles } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]/invoice_task_files';
import { BackofficeQuotationTask } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]';
import { BackofficeQuotationTaskEdit } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/edit';
import { BackofficeQuotationTaskFiles } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/quotation_task_files';
import { BackofficeSalesOrderContractTask } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]';
import { BackofficeSalesOrderContractTaskEdit } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/edit';
import { BackofficeSalesOrderContractTaskFiles } from '@/features/w/[identifier]/backoffice/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/sales_order_contract_task_files';
import { PlDashboard } from '@/features/w/[identifier]/dashboard/pl';
import { PurchaseOrdersDashboard } from '@/features/w/[identifier]/dashboard/purchase_orders';
import { SalesOrdersDashboard } from '@/features/w/[identifier]/dashboard/sales_orders';
import { TasksDashboard } from '@/features/w/[identifier]/dashboard/tasks';
import { WeeklyComparison } from '@/features/w/[identifier]/dashboard/weekly_comparison';
import { FinanceExports } from '@/features/w/[identifier]/finance/finance_exports';
import { FixedAssets } from '@/features/w/[identifier]/finance/fixed_assets';
import { FixedAsset } from '@/features/w/[identifier]/finance/fixed_assets/[fixed_asset_id]';
import { FixedAssetEdit } from '@/features/w/[identifier]/finance/fixed_assets/[fixed_asset_id]/edit';
import { FixedAssetsNew } from '@/features/w/[identifier]/finance/fixed_assets/new';
import { WorkspaceSetting } from '@/features/w/[identifier]/setting';
import { WorkspaceBusinessPartners } from '@/features/w/[identifier]/setting/business_partners';
import { WorkspaceBusinessPartnersEdit } from '@/features/w/[identifier]/setting/business_partners/[id]/edit';
import { WorkspaceBusinessPartnersNew } from '@/features/w/[identifier]/setting/business_partners/new';
import { WorkspaceConnect } from '@/features/w/[identifier]/setting/connect';
import { BoardConnectNew } from '@/features/w/[identifier]/setting/connect/board/new';
import { MoneyForwardConnectCallback } from '@/features/w/[identifier]/setting/connect/mf/callback';
import { MoneyForwardConnectNew } from '@/features/w/[identifier]/setting/connect/mf/new';
import { DataImport } from '@/features/w/[identifier]/setting/data_import';
import { EditWorkspaceBasic } from '@/features/w/[identifier]/setting/edit_basic';
import { EditWorkspaceDetail } from '@/features/w/[identifier]/setting/edit_detail';
import { EditMonthlyExternalExpenses } from '@/features/w/[identifier]/setting/edit_monthly_external_expenses';
import { EditNextPlan } from '@/features/w/[identifier]/setting/edit_next_plan';
import { EditPaymentMethod } from '@/features/w/[identifier]/setting/edit_payment_method';
import { WorkspaceMembers } from '@/features/w/[identifier]/setting/members';
import { WorkspaceUserEdit } from '@/features/w/[identifier]/setting/members/[id]/edit';
import { WorkspaceNewInvitation } from '@/features/w/[identifier]/setting/members/new_invitation';
import { WorkspaceProducts } from '@/features/w/[identifier]/setting/products';
import { WorkspaceProductEdit } from '@/features/w/[identifier]/setting/products/[id]/edit';
import { WorkspaceProductsNew } from '@/features/w/[identifier]/setting/products/new';
import { WorkspaceTeams } from '@/features/w/[identifier]/setting/teams';
import { WorkspaceTeam } from '@/features/w/[identifier]/setting/teams/[team_id]';
import { WorkspaceTeamEdit } from '@/features/w/[identifier]/setting/teams/[team_id]/edit';
import { MonthlyOrderingBudgets } from '@/features/w/[identifier]/setting/teams/[team_id]/monthly_ordering_budgets';
import { MonthlySalesTargets } from '@/features/w/[identifier]/setting/teams/[team_id]/monthly_sales_targets';
import { TeamMemberEdit } from '@/features/w/[identifier]/setting/teams/[team_id]/team_members/[team_member_id]/edit';
import { TeamMembersNew } from '@/features/w/[identifier]/setting/teams/[team_id]/team_members/new';
import { TeamTaskPhaseSettingEdit } from '@/features/w/[identifier]/setting/teams/[team_id]/team_phase_skip_setting';
import { TeamPurchaseOrderPhaseEdit } from '@/features/w/[identifier]/setting/teams/[team_id]/team_purchase_order_phases/[phase_id]/edit';
import { TeamSalesOrderPhaseEdit } from '@/features/w/[identifier]/setting/teams/[team_id]/team_sales_order_phases/[phase_id]/edit';
import { WorkspaceTeamsNew } from '@/features/w/[identifier]/setting/teams/new';
import { WorkspacePayments } from '@/features/w/[identifier]/setting/workspace_payments';
import { WorkspacePurchaseOrderPhaseEdit } from '@/features/w/[identifier]/setting/workspace_purchase_order_phase/[phase_id]/edit';
import { WorkspaceSalesOrderPhaseEdit } from '@/features/w/[identifier]/setting/workspace_sales_order_phase/[phase_id]/edit';
import { TeamPurchaseOrders } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders';
import { TeamPurchaseOrder } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]';
import { PurchaseOrderEdit } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/edit';
import { PaymentSchedules } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_schedules';
import { PaymentTask } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]';
import { PaymentTaskEdit } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/edit';
import { PaymentTaskExpenseAccountItems } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_expense_account_items';
import { PaymentTaskFiles } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_files';
import { PaymentTaskFixedAssets } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_fixed_assets';
import { PaymentTaskOrderAllocatedExpenses } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/[payment_task_id]/payment_task_order_allocated_expenses';
import { PaymentTasksNew } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/payment_tasks/new';
import { PurchaseOrderContractTask } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]';
import { PurchaseOrderContractTaskEdit } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/edit';
import { PurchaseOrderContractTaskFiles } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/[purchase_order_contract_task_id]/purchase_order_contract_task_files';
import { PurchaseOrderContractTasksNew } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_contract_tasks/new';
import { PurchaseOrderMembers } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/purchase_order_members';
import { PurchaseOrderRelatedProjects } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/related_projects';
import { PurchaseOrdersNew } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/new';
import { TeamSalesOrders } from '@/features/w/[identifier]/teams/[team_id]/sales_orders';
import { TeamSalesOrder } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]';
import { BillingSchedules } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/billing_schedules';
import { SalesOrderEdit } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/edit';
import { InvoiceTask } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]';
import { InvoiceTaskEdit } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]/edit';
import { InvoiceTaskFiles } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/[invoice_task_id]/invoice_task_files';
import { InvoiceTasksNew } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/invoice_tasks/new';
import { QuotationTask } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]';
import { QuotationTaskEdit } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/edit';
import { QuotationTaskFiles } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/[quotation_task_id]/quotation_task_files';
import { QuotationTasksNew } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/quotation_tasks/new';
import { SalesOrderContractTask } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]';
import { SalesOrderContractTaskEdit } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/edit';
import { SalesOrderContractTaskFiles } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/[sales_order_contract_task_id]/sales_order_contract_task_files';
import { SalesOrderContractTasksNew } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_contract_tasks/new';
import { SalesOrderMembers } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/sales_order_members';
import { SalesOrdersNew } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/new';
import { NotificationSetting } from '@/features/w/[identifier]/user_setting/notification';
import { SlackConnectCallback } from '@/features/w/[identifier]/user_setting/notification/connect/slack/callback';
import { Workspaces } from '@/features/workspaces';
import { WorkspacesNew } from '@/features/workspaces/new';
import { PaymentFailure } from '@/features/workspaces/PaymentFailure';
import { useCsrfToken } from '@/hooks/api/0000_csrf_token';
import { usePageTracking } from '@/hooks/usePageTracking';
import { FixedAssetProvider } from '@/providers/FixedAssetProvider';
import { InvoiceTaskProvider } from '@/providers/InvoiceTaskProvider';
import { PaymentTaskProvider } from '@/providers/PaymentTaskProvider';
import { PurchaseOrderContractTaskProvider } from '@/providers/PurchaseOrderContractTaskProvider';
import { PurchaseOrderProvider } from '@/providers/PurchaseOrderProvider';
import { QuotationTaskProvider } from '@/providers/QuotationTaskProvider';
import { SalesOrderContractTaskProvider } from '@/providers/SalesOrderContractTaskProvider';
import { SalesOrderProvider } from '@/providers/SalesOrderProvider';
import { useCallback, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { EditRenewedSalesOrders } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/renewed_sales_orders';
import { EditRenewedPurchaseOrders } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/renewed_purchase_orders';

type RouteDef = {
  path: string;
  element: React.ReactNode;
  requireSignIn?: boolean;
  requireWorkspaceMember?: boolean;
  requireTeam?: boolean;
  loadTeamMember?: boolean;
  requirePurchaseOrder?: boolean;
  requirePurchaseOrderContractTask?: boolean;
  requirePaymentTask?: boolean;
  requireSalesOrder?: boolean;
  requireSalesOrderContractTask?: boolean;
  requireQuotationTask?: boolean;
  requireInvoiceTask?: boolean;
  requireFixedAsset?: boolean;
  children?: RouteDef[];
};

// ドットはルーティングに使用不可（cloudfront functionsでreactのルーティングを制御しているロジックの仕様のため）
const routes: RouteDef[] = [
  {
    path: '/sign_up',
    element: <SignUp />,
    children: [
      {
        path: 'verify_code',
        element: <SignUpVerifyCode />,
      },
    ],
  },
  { path: '/sign_in', element: <SignIn /> },
  {
    path: '/password_reset',
    element: <PasswordReset />,
    children: [
      {
        path: 'new',
        element: <PasswordResetNew />,
      },
      {
        path: 'code',
        element: <PasswordResetCode />,
      },
    ],
  },
  {
    path: '/payment_failure/:token',
    element: <PaymentFailure />,
  },
  { path: '/', element: <Navigate replace to={'/workspaces'} /> },
  {
    path: '/my_profile',
    element: <MyProfile />,
    requireSignIn: true,
    children: [
      {
        path: 'edit_password',
        element: <EditPassword />,
      },
    ],
  },
  {
    path: '/workspaces',
    element: <Workspaces />,
    requireSignIn: true,
    children: [
      {
        path: 'new',
        element: <WorkspacesNew />,
      },
    ],
  },
  {
    path: '/w/:identifier',
    element: <TasksDashboard />,
    requireSignIn: true,
    requireWorkspaceMember: true,
    children: [
      {
        path: 'dashboard/tasks',
        element: <TasksDashboard />,
      },
      {
        path: 'dashboard/sales_orders',
        element: <SalesOrdersDashboard />,
      },
      {
        path: 'dashboard/purchase_orders',
        element: <PurchaseOrdersDashboard />,
      },
      {
        path: 'dashboard/weekly_comparison',
        element: <WeeklyComparison />,
      },
      {
        path: 'dashboard/pl',
        element: <PlDashboard />,
      },
      {
        path: 'teams/:team_id/purchase_orders',
        requireTeam: true,
        loadTeamMember: true,
        element: <TeamPurchaseOrders />,
        children: [
          {
            path: 'new',
            element: <PurchaseOrdersNew />,
          },
          {
            path: ':purchase_order_id',
            element: <TeamPurchaseOrder />,
            requirePurchaseOrder: true,
            children: [
              {
                path: 'edit',
                element: <PurchaseOrderEdit />,
              },
              {
                path: 'purchase_order_members',
                element: <PurchaseOrderMembers />,
              },
              {
                path: 'payment_schedules',
                element: <PaymentSchedules />,
              },
              {
                path: 'purchase_order_contract_tasks/new',
                element: <PurchaseOrderContractTasksNew />,
              },
              {
                path: 'related_projects',
                element: <PurchaseOrderRelatedProjects />,
              },
              {
                path: 'purchase_order_contract_tasks/:purchase_order_contract_task_id',
                element: <PurchaseOrderContractTask />,
                requirePurchaseOrderContractTask: true,
                children: [
                  {
                    path: 'edit',
                    element: <PurchaseOrderContractTaskEdit />,
                  },
                  {
                    path: 'purchase_order_contract_task_files',
                    element: <PurchaseOrderContractTaskFiles />,
                  },
                ],
              },
              {
                path: 'payment_tasks/new',
                element: <PaymentTasksNew />,
              },
              {
                path: 'payment_tasks/:payment_task_id',
                element: <PaymentTask />,
                requirePaymentTask: true,
                children: [
                  {
                    path: 'edit',
                    element: <PaymentTaskEdit />,
                  },
                  {
                    path: 'payment_task_files',
                    element: <PaymentTaskFiles />,
                  },
                  {
                    path: 'payment_task_fixed_assets',
                    element: <PaymentTaskFixedAssets />,
                  },
                  {
                    path: 'payment_task_expense_account_items',
                    element: <PaymentTaskExpenseAccountItems />,
                  },
                  {
                    path: 'payment_task_order_allocated_expenses',
                    element: <PaymentTaskOrderAllocatedExpenses />,
                  },
                ],
              },
              {
                path: 'renewed_purchase_orders',
                element: <EditRenewedPurchaseOrders />,
              },
            ],
          },
        ],
      },
      {
        path: 'teams/:team_id/sales_orders',
        requireTeam: true,
        loadTeamMember: true,
        element: <TeamSalesOrders />,
        children: [
          {
            path: 'new',
            element: <SalesOrdersNew />,
          },
          {
            path: ':sales_order_id',
            element: <TeamSalesOrder />,
            requireSalesOrder: true,
            children: [
              {
                path: 'edit',
                element: <SalesOrderEdit />,
              },
              {
                path: 'sales_order_members',
                element: <SalesOrderMembers />,
              },
              {
                path: 'billing_schedules',
                element: <BillingSchedules />,
              },
              {
                path: 'sales_order_contract_tasks/new',
                element: <SalesOrderContractTasksNew />,
              },
              {
                path: 'sales_order_contract_tasks/:sales_order_contract_task_id',
                element: <SalesOrderContractTask />,
                requireSalesOrderContractTask: true,
                children: [
                  {
                    path: 'edit',
                    element: <SalesOrderContractTaskEdit />,
                  },
                  {
                    path: 'sales_order_contract_task_files',
                    element: <SalesOrderContractTaskFiles />,
                  },
                ],
              },
              {
                path: 'quotation_tasks/new',
                element: <QuotationTasksNew />,
              },
              {
                path: 'quotation_tasks/:quotation_task_id',
                element: <QuotationTask />,
                requireQuotationTask: true,
                children: [
                  {
                    path: 'edit',
                    element: <QuotationTaskEdit />,
                  },
                  {
                    path: 'quotation_task_files',
                    element: <QuotationTaskFiles />,
                  },
                ],
              },
              {
                path: 'invoice_tasks/new',
                element: <InvoiceTasksNew />,
              },
              {
                path: 'invoice_tasks/:invoice_task_id',
                element: <InvoiceTask />,
                requireInvoiceTask: true,
                children: [
                  {
                    path: 'edit',
                    element: <InvoiceTaskEdit />,
                  },
                  {
                    path: 'invoice_task_files',
                    element: <InvoiceTaskFiles />,
                  },
                ],
              },
              {
                path: 'renewed_sales_orders',
                element: <EditRenewedSalesOrders />,
              },
            ],
          },
        ],
      },
      {
        path: 'backoffice/purchase_order_contract_tasks',
        element: <BackofficePurchaseOrderContractTasks />,
      },
      {
        path: 'backoffice/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id',
        element: <BackofficePurchaseOrderContractTask />,
        requireTeam: true,
        loadTeamMember: true,
        requirePurchaseOrderContractTask: true,
        children: [
          {
            path: 'edit',
            element: <BackofficePurchaseOrderContractTaskEdit />,
          },
          {
            path: 'purchase_order_contract_task_files',
            element: <BackofficePurchaseOrderContractTaskFiles />,
          },
        ],
      },
      {
        path: 'backoffice/payment_tasks',
        element: <BackofficePaymentTasks />,
      },
      {
        path: 'backoffice/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:payment_task_id',
        element: <BackofficePaymentTask />,
        requireTeam: true,
        loadTeamMember: true,
        requirePaymentTask: true,
        children: [
          {
            path: 'edit',
            element: <BackofficePaymentTaskEdit />,
          },
          {
            path: 'payment_task_files',
            element: <BackofficePaymentTaskFiles />,
          },
          {
            path: 'payment_task_fixed_assets',
            element: <BackofficePaymentTaskFixedAssets />,
          },
          {
            path: 'payment_task_expense_account_items',
            element: <BackofficePaymentTaskExpenseAccountItems />,
          },
          {
            path: 'payment_task_order_allocated_expenses',
            element: <BackofficePaymentTaskOrderAllocatedExpenses />,
          },
        ],
      },
      {
        path: 'backoffice/sales_order_contract_tasks',
        element: <BackofficeSalesOrderContractTasks />,
      },
      {
        path: 'backoffice/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id',
        element: <BackofficeSalesOrderContractTask />,
        requireTeam: true,
        loadTeamMember: true,
        requireSalesOrderContractTask: true,
        children: [
          {
            path: 'edit',
            element: <BackofficeSalesOrderContractTaskEdit />,
          },
          {
            path: 'sales_order_contract_task_files',
            element: <BackofficeSalesOrderContractTaskFiles />,
          },
        ],
      },
      {
        path: 'backoffice/quotation_tasks',
        element: <BackofficeQuotationTasks />,
      },
      {
        path: 'backoffice/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id',
        element: <BackofficeQuotationTask />,
        requireTeam: true,
        loadTeamMember: true,
        requireQuotationTask: true,
        children: [
          {
            path: 'edit',
            element: <BackofficeQuotationTaskEdit />,
          },
          {
            path: 'quotation_task_files',
            element: <BackofficeQuotationTaskFiles />,
          },
        ],
      },
      {
        path: 'backoffice/invoice_tasks',
        element: <BackofficeInvoiceTasks />,
      },
      {
        path: 'backoffice/teams/:team_id/sales_orders/:sales_order_id/invoice_tasks/:invoice_task_id',
        element: <BackofficeInvoiceTask />,
        requireTeam: true,
        loadTeamMember: true,
        requireInvoiceTask: true,
        children: [
          {
            path: 'edit',
            element: <BackofficeInvoiceTaskEdit />,
          },
          {
            path: 'invoice_task_files',
            element: <BackofficeInvoiceTaskFiles />,
          },
        ],
      },
      {
        path: 'approval',
        element: <ApprovalTasks />,
      },
      {
        path: 'approval/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id',
        element: <ApprovalPurchaseOrderContractTask />,
        requireTeam: true,
        loadTeamMember: true,
        requirePurchaseOrder: true,
        requirePurchaseOrderContractTask: true,
        children: [
          {
            path: 'edit',
            element: <ApprovalPurchaseOrderContractTaskEdit />,
          },
          {
            path: 'purchase_order_contract_task_files',
            element: <ApprovalPurchaseOrderContractTaskFiles />,
          },
        ],
      },
      {
        path: 'approval/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id',
        element: <ApprovalSalesOrderContractTask />,
        requireTeam: true,
        loadTeamMember: true,
        requireSalesOrder: true,
        requireSalesOrderContractTask: true,
        children: [
          {
            path: 'edit',
            element: <ApprovalSalesOrderContractTaskEdit />,
          },
          {
            path: 'sales_order_contract_task_files',
            element: <ApprovalSalesOrderContractTaskFiles />,
          },
        ],
      },
      {
        path: 'approval/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id',
        element: <ApprovalQuotationTask />,
        requireTeam: true,
        loadTeamMember: true,
        requireSalesOrder: true,
        requireQuotationTask: true,
        children: [
          {
            path: 'edit',
            element: <ApprovalQuotationTaskEdit />,
          },
          {
            path: 'quotation_task_files',
            element: <ApprovalQuotationTaskFiles />,
          },
        ],
      },
      {
        path: 'finance/fixed_assets',
        element: <FixedAssets />,
        children: [
          {
            path: 'new',
            element: <FixedAssetsNew />,
          },
          {
            path: ':fixed_asset_id',
            element: <FixedAsset />,
            requireFixedAsset: true,
            children: [
              {
                path: 'edit',
                element: <FixedAssetEdit />,
              },
            ],
          },
        ],
      },
      {
        path: 'finance/finance_exports',
        element: <FinanceExports />,
      },
      {
        path: 'user_setting/notification',
        element: <NotificationSetting />,
        children: [
          {
            path: 'connect/slack/callback',
            element: <SlackConnectCallback />,
          },
        ],
      },
      {
        path: 'setting',
        element: <WorkspaceSetting />,
        children: [
          // {
          //   path: 'stripe_demo',
          //   element: <StripeDemo />,
          // },
          {
            path: 'edit_basic',
            element: <EditWorkspaceBasic />,
          },
          {
            path: 'edit_detail',
            element: <EditWorkspaceDetail />,
          },
          {
            path: 'edit_next_plan',
            element: <EditNextPlan />,
          },
          {
            path: 'edit_payment_method',
            element: <EditPaymentMethod />,
          },
          {
            path: 'workspace_payments',
            element: <WorkspacePayments />,
          },
          {
            path: 'edit_monthly_external_expenses',
            element: <EditMonthlyExternalExpenses />,
          },
          {
            path: 'workspace_sales_order_phases/:phase_id/edit',
            element: <WorkspaceSalesOrderPhaseEdit />,
          },
          {
            path: 'workspace_purchase_order_phases/:phase_id/edit',
            element: <WorkspacePurchaseOrderPhaseEdit />,
          },
          {
            path: 'members',
            element: <WorkspaceMembers />,
            children: [
              {
                path: 'new_invitation',
                element: <WorkspaceNewInvitation />,
              },
              {
                path: ':id/edit',
                element: <WorkspaceUserEdit />,
              },
            ],
          },
          {
            path: 'teams',
            element: <WorkspaceTeams />,
            children: [
              {
                path: 'new',
                element: <WorkspaceTeamsNew />,
              },
              {
                path: ':team_id',
                element: <WorkspaceTeam />,
                requireTeam: true,
                children: [
                  {
                    path: 'edit',
                    element: <WorkspaceTeamEdit />,
                  },
                  {
                    path: 'team_members/new',
                    element: <TeamMembersNew />,
                  },
                  {
                    path: 'team_members/:team_member_id/edit',
                    element: <TeamMemberEdit />,
                  },
                  {
                    path: 'team_sales_order_phases/:phase_id/edit',
                    element: <TeamSalesOrderPhaseEdit />,
                  },
                  {
                    path: 'team_purchase_order_phases/:phase_id/edit',
                    element: <TeamPurchaseOrderPhaseEdit />,
                  },
                  {
                    path: 'monthly_sales_targets',
                    element: <MonthlySalesTargets />,
                  },
                  {
                    path: 'monthly_ordering_budgets',
                    element: <MonthlyOrderingBudgets />,
                  },
                  {
                    path: 'team_phase_skip_setting/edit',
                    element: <TeamTaskPhaseSettingEdit />,
                  },
                ],
              },
            ],
          },
          {
            path: 'products',
            element: <WorkspaceProducts />,
            children: [
              {
                path: 'new',
                element: <WorkspaceProductsNew />,
              },
              {
                path: ':id/edit',
                element: <WorkspaceProductEdit />,
              },
            ],
          },
          {
            path: 'business_partners',
            element: <WorkspaceBusinessPartners />,
            children: [
              {
                path: 'new',
                element: <WorkspaceBusinessPartnersNew />,
              },
              {
                path: ':id/edit',
                element: <WorkspaceBusinessPartnersEdit />,
              },
            ],
          },
          {
            path: 'connect',
            element: <WorkspaceConnect />,
            children: [
              {
                path: 'mf/new',
                element: <MoneyForwardConnectNew />,
              },
              {
                path: 'mf/callback',
                element: <MoneyForwardConnectCallback />,
              },
              {
                path: 'board/new',
                element: <BoardConnectNew />,
              },
            ],
          },
          {
            path: 'data_import',
            element: <DataImport />,
          },
        ],
      },
    ],
  },
];

export const AppRouter = () => {
  const location = useLocation();
  const { refetch } = useCsrfToken();

  usePageTracking();

  useEffect(() => {
    refetch();
  }, []);

  const createRouteElement = useCallback(
    ({
      element,
      requireSignIn,
      requireWorkspaceMember,
      requireTeam,
      loadTeamMember,
      requirePurchaseOrder,
      requirePurchaseOrderContractTask,
      requirePaymentTask,
      requireSalesOrder,
      requireSalesOrderContractTask,
      requireQuotationTask,
      requireInvoiceTask,
      requireFixedAsset,
    }: RouteDef): React.ReactNode => {
      let el = element;
      if (requireFixedAsset) {
        el = (
          <FixedAssetProvider>
            <RequireFixedAsset>{el}</RequireFixedAsset>
          </FixedAssetProvider>
        );
      }
      if (requirePurchaseOrder) {
        el = (
          <PurchaseOrderProvider>
            <RequirePurchaseOrder>{el}</RequirePurchaseOrder>
          </PurchaseOrderProvider>
        );
      }
      if (requireSalesOrder) {
        el = (
          <SalesOrderProvider>
            <RequireSalesOrder>{el}</RequireSalesOrder>
          </SalesOrderProvider>
        );
      }
      if (requirePurchaseOrderContractTask) {
        el = (
          <PurchaseOrderContractTaskProvider>
            <RequirePurchaseOrderContractTask>{el}</RequirePurchaseOrderContractTask>
          </PurchaseOrderContractTaskProvider>
        );
      }
      if (requireSalesOrderContractTask) {
        el = (
          <SalesOrderContractTaskProvider>
            <RequireSalesOrderContractTask>{el}</RequireSalesOrderContractTask>
          </SalesOrderContractTaskProvider>
        );
      }
      if (requireQuotationTask) {
        el = (
          <QuotationTaskProvider>
            <RequireQuotationTask>{el}</RequireQuotationTask>
          </QuotationTaskProvider>
        );
      }
      if (requirePaymentTask) {
        el = (
          <PaymentTaskProvider>
            <RequirePaymentTask>{el}</RequirePaymentTask>
          </PaymentTaskProvider>
        );
      }
      if (requireInvoiceTask) {
        el = (
          <InvoiceTaskProvider>
            <RequireInvoiceTask>{el}</RequireInvoiceTask>
          </InvoiceTaskProvider>
        );
      }
      if (loadTeamMember) {
        el = <LoadTeamMember>{el}</LoadTeamMember>;
      }
      if (requireTeam) {
        el = <RequireTeam>{el}</RequireTeam>;
      }
      if (requireWorkspaceMember) {
        el = <RequireWorkspaceMember>{el}</RequireWorkspaceMember>;
      }
      if (requireSignIn) {
        el = <RequireSignIn>{el}</RequireSignIn>;
      }
      return el;
    },
    []
  );

  const createRoute = useCallback((routeDef: RouteDef) => {
    if (routeDef.children) {
      return (
        <Route key={routeDef.path} path={routeDef.path}>
          <Route index element={createRouteElement(routeDef)} />
          {routeDef.children &&
            routeDef.children.map((c) =>
              createRoute({
                requireSignIn: routeDef.requireSignIn,
                requireWorkspaceMember: routeDef.requireWorkspaceMember,
                requireTeam: routeDef.requireTeam,
                loadTeamMember: routeDef.loadTeamMember,
                requirePurchaseOrder: routeDef.requirePurchaseOrder,
                requirePurchaseOrderContractTask: routeDef.requirePurchaseOrderContractTask,
                requirePaymentTask: routeDef.requirePaymentTask,
                requireSalesOrder: routeDef.requireSalesOrder,
                requireSalesOrderContractTask: routeDef.requireSalesOrderContractTask,
                requireQuotationTask: routeDef.requireQuotationTask,
                requireInvoiceTask: routeDef.requireInvoiceTask,
                requireFixedAsset: routeDef.requireFixedAsset,
                ...c,
              })
            )}
        </Route>
      );
    } else {
      return <Route key={routeDef.path} path={routeDef.path} element={createRouteElement(routeDef)} />;
    }
  }, []);

  return <Routes>{routes.map((routeDef) => createRoute(routeDef))}</Routes>;
};
